import { MatDialogConfig } from '@angular/material/dialog';

interface DialogConfig {
  minWidth: string;
  mobile?: { width: string; left: string };
}

export function getDialogConfig(config: DialogConfig): MatDialogConfig {
  const dialogConfig = new MatDialogConfig();

  const mobile = config.mobile || { width: '98vw', left: '1vw' };

  if (window.innerWidth <= 600) {
    dialogConfig.width = mobile.width;
    dialogConfig.maxWidth = mobile.width;
    dialogConfig.position = { left: mobile.left };
  } else {
    dialogConfig.minWidth = config.minWidth;
  }

  return dialogConfig;
}
